import React from "react";
import { ActionProps } from "react-querybuilder";

export const CustomRemoveGroupAction: React.FC<ActionProps> = (props) => {
    return null;
};
